<template>
  <div>
  <vue-header/>
  <div v-if="showAssignmentWarningPopup" class="assignment-warning-overlay" @click="cancelAssignmentWarning">
    <div class="assignment-warning-modal" @click.stop>
      <h3>Lineup Assignment Warning</h3>
      <p>You are not assigned to that job on that date. Are you sure you want to proceed?</p>
      <div class="assignment-warning-actions">
        <button type="button" class="btn btn-save" @click="continueAfterAssignmentWarning">Continue</button>
        <button type="button" class="btn btn-secondary" @click="cancelAssignmentWarning">Cancel</button>
      </div>
    </div>
  </div>
  <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="true">
          </loading>
    <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">

          <router-link :to="'/timesheets/currentView/'+$route.params.id" tag="button">
         <i class="fa fa-arrow-circle-left" style="font-size:25px;margin-bottom:10px;cursor:pointer;" ></i>
          </router-link>
          <div class="card">
            <div class="card-header bg-dark text-white" style="text-align:center;">
              <h1 style="font-size:18px;" v-if="!$route.params.detailId">Add Timesheet</h1>
              <h1 style="font-size:18px;" v-else>Edit Timesheet</h1>
              <small style="font-weight: normal;font-size: 13px;">(Period {{moment(pastDateStart).format('MM/DD/YYYY')}} -
            {{moment(pastDateEnd).format('MM/DD/YYYY')}})
            </small>
            </div>
            <div class="card-body">
                <b-row class="my-1" style="margin-bottom: 13px !important;">
                  <!-- <b-col sm="2">
                    <label for="input-default">Rework?</label>
                  </b-col> -->
                  <b-col sm="12">
                     <b-form-checkbox-group  id="checkboxes-4">
                        <b-form-checkbox v-model="timesheetData.rework" value="1" unchecked-value="0" class="form-checkbox" size="lg">Rework?</b-form-checkbox>
                     </b-form-checkbox-group>
                  </b-col>
                </b-row>
                <div class="clearfix"></div>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Time In<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime type="datetime" use12-hour class=""
                    :min-datetime="initDate.inStart"
                    :max-datetime="initDate.inEnd"
                    v-model="timesheetData.timeIn"
                    v-on:input="calculateTotalHours"
                    ></datetime>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Time Out<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime type="datetime" use12-hour class=""
                    :min-datetime="initDate.outStart"
                    :max-datetime="initDate.outEnd"
                    v-model="timesheetData.timeOut"
                    v-on:input="calculateTotalHours"
                    ></datetime>
                    <!-- <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded" ></b-form-input> -->
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Break(Mins)</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="timesheetData.break"
                    autocomplete="off"
                    @keyup="calculateTotalHours"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Total Hours</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    disabled
                     v-model="timesheetData.totalHour"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Job<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <vue-bootstrap-typeahead
                    :minMatchingChars = 1
                    class="shadow-sm"
                    placeholder="Search Job"
                    :maxMatches = 100
                    ref="job"
                    v-model="timesheetData.job"
                    :serializer="item => item.value"
                    :data="job_option"
                    @hit="selectedJob($event)"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Task Category<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="timesheetData.category" :options="task_option" style="color: black;"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Description</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-textarea
                      style="color: black;"
                      id="textarea-small"
                      v-model="timesheetData.description"
                      class="shadow-sm p-3 mb-3 bg-white rounded"
                    ></b-form-textarea>
                  </b-col>
                </b-row>
                <div class="clearfix"></div>
                <div class="form-group" style="text-align: center;margin-top:8px;">
                <button type="button" class="btn btn-save shadow" :disabled="isSaved" @click="saveTimesheet"> Save  </button>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
let canSave = true;
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
name: 'AddTimesheet',
components : {Loading,Datetime,VueBootstrapTypeahead},
data() {
    return {
      constants: CommonConstants,
      header: {},
      isLoading: true,
      moment: moment,
      pastDateStart :'',
      pastDateEnd :'',
      task_option:[],
      isSaved : false,
      showAssignmentWarningPopup: false,
      pendingUpdatePostData: null,
      job_option: [],
      originalJobId: '',
      timesheet_detail_prev : [],
      initDate : {
        inStart :"",
        inEnd :"",
        outStart :"",
        outEnd:"",


      },
      timesheetData : {
        timeIn : moment().format(),
        timeOut : moment().format(),
        break :0,
        totalHour:0,
        job: "",
        category:"",
        description:"",
        rework: ""

      }
    }
  },
  mounted (){
    this.getFormData();
    this.job_option = JSON.parse(localStorage.getItem('jobs_status_json'));
    console.log(this.job_option);
  },
  methods : {
    getFormData (){
      let self = this;
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      axios.get(self.constants.api_url + 'timesheet/view/' + self.$route.params.id, header)
      .then(function (response) {
        if (response.data.flag !== true) {
          Vue.$toast.error(response.data.message || "Failed to load timesheet", { position: "top" });
          self.isLoading = false;
          return;
        }
        let res = response.data.data;
        console.log("AddCurrentTimesheet response data:", res);
        self.pastDateStart = res.timesheet.period_start;
        self.pastDateEnd = res.timesheet.period_end;
        self.timesheet_detail_prev  = res.timesheet_details;
        self.initDate.inStart = res.timesheet.period_start;
        self.initDate.inEnd = res.timesheet.period_end;
        self.initDate.outStart = res.timesheet.period_start;
        self.initDate.outEnd = res.timesheet.period_end;
        if(self.$route.params.detailId){
          res.timesheet_details.forEach(element => {
            if(element.id == self.$route.params.detailId){
              self.timesheetData.rework = element.rework_check;
              self.timesheetData.timeIn = moment(element.date_in).format();
              self.timesheetData.timeOut =  moment(element.date_out).format();
              self.timesheetData.break = element.break;
              self.timesheetData.totalHour = element.total;
              self.originalJobId = element.job_id ? element.job_id.toString() : '';
              self.timesheetData.job = self.originalJobId;
              self.$refs.job.inputValue = element.job_number+' - '+element.job_name
              self.timesheetData.category = element.task;
              self.timesheetData.description = element.description;
            }
          });
        }
        let temp;

        for (var d of res.task_select) {
          temp = {text: d.value, value:d.id}
          self.task_option.push(temp)
        }
        self.isLoading = false;
        axios.get(self.constants.api_url + 'jobs-status-input-ajax',header)
          .then(function (res) {
            self.loader = true
            let t = res.data.data
            var tmp = {}
            var jobs = []
            for (var d of t) {
              tmp = {id: d.job_id, value: d.description.toString().substring(2) + ' - '+d.title}
              jobs.push(tmp)
            }
            localStorage.setItem('jobs_status_json', JSON.stringify(jobs));
            self.job_option = jobs;
            self.isLoading = false;
          })
          .catch(e => {
            console.error("Error loading jobs:", e);
            self.isLoading = false;
          })
        })
        .catch(e => {
          console.error("Error loading timesheet view:", e);
          self.isLoading = false;
        })
    },
    timeOverlapChecker(data) {
      let tmp2 = [];
      let flag = 0;
      this.timesheet_detail_prev.forEach(function(val, key) {
        tmp2[key] = val;
        if(val.id == data['id']){
          tmp2[key]['date_in'] = data['date_in'];
          tmp2[key]['date_out'] = data['date_out'];
          flag =1;
        }
      });
      if(flag == 0){
        tmp2.push({id:data['id'],date_in: data['date_in'], date_out: data['date_out']});
      }
        let temp = tmp2;
        let timeSheets = [];
        for (let t in temp) {
          timeSheets.push(temp[t])
        }
        timeSheets.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.date_in) - new Date(a.date_in);
        });
        let ts1;
        let ts2;
        let len = timeSheets.length;
        if (len >= 2) {
          for (let t = 0; t < len - 1; t++) {
            ts1 = timeSheets[t];
            ts2 = timeSheets[t + 1];
            if (moment(ts2.date_in).isSameOrAfter(moment(ts1.date_in)) && moment(ts2.date_in).isBefore(moment(ts1.date_out))) {
              Vue.$toast.error('Overlapping Time Entries', {
                position: 'top'
              });
              return false
            }
            if (moment(ts2.date_in).isSameOrBefore(moment(ts1.date_in)) && moment(ts2.date_out).isSameOrAfter(moment(ts1.date_in))) {
              Vue.$toast.error('Overlapping Time Entries', {
                position: 'top'
              });
              return false
            }
          }
          return true
        }
        return true
      },
    saveTimesheet (){
      if (this.isSaved) return;
      let self = this;
      console.log(self.timesheetData.rework );
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      let flag = 1;
      if (self.timesheetData.job == '') {
            Vue.$toast.error('Please select a job', {
            position: 'top'
            });
          flag = 0;
          return false;
      }else if (self.timesheetData.category == '') {
            Vue.$toast.error('Please select a Task Category', {
            position: 'top'
            });
          flag = 0;
          return false;
      }
      let job_option_status = false;
      for (var job of self.job_option) {
        if (job.id == self.timesheetData.job) {
          job_option_status = true
          break
        }
      }
      if (job_option_status == false && self.$route.params.detailId && self.originalJobId !== '' && self.timesheetData.job == self.originalJobId) {
        job_option_status = true
      }
      if (job_option_status == false) {
            Vue.$toast.error('Invalid job seleted', {
            position: 'top'
            });
          flag = 0;
          return false;
      }
      let dur = moment.duration(moment(self.timesheetData.timeOut).diff(moment(moment(self.timesheetData.timeIn))));
      let total = 0;
      let tmp_total = 0;
      total = dur.asHours().toFixed(2);
      tmp_total = total - (self.timesheetData.break / 60)
      total = tmp_total.toFixed(2)
      if (total < 0 && flag == 1) {
       Vue.$toast.error('Invalid Break, Must be Positive.', {
            position: 'top'
            });
       flag = 0;
       return false;
      }
      if(moment(self.timesheetData.timeOut).format('YYYY-MM-DD HH:mm:ss A') > moment().format('YYYY-MM-DD HH:mm:ss A') && flag ==1){
          Vue.$toast.error('Can not enter time in the future', {
            position: 'top'
            });
          return false;
          flag = 0;
          return false;
      }
      let temp_data = [];
      temp_data["id"] = (self.$route.params.detailId) ? self.$route.params.detailId : "temp_".concat(Math.random());
      temp_data["date_in"] = moment(self.timesheetData.timeIn).format('YYYY-MM-DD HH:mm:ss');
      temp_data["date_out"] = moment(self.timesheetData.timeOut).format('YYYY-MM-DD HH:mm:ss');
      if (this.timeOverlapChecker(temp_data) && flag ==1) {
            let request = [];
            let tmp = {};
            tmp["timesheet_detail_id"] =  (self.$route.params.detailId) ? self.$route.params.detailId : "temp_".concat(Math.random()) ;
            tmp["date_in"] = moment(self.timesheetData.timeIn).format('YYYY-MM-DD HH:mm:ss');
            tmp["date_out"] = moment(self.timesheetData.timeOut).format('YYYY-MM-DD HH:mm:ss');
            tmp["break"] = self.timesheetData.break == "" ? 0 : self.timesheetData.break;
            tmp["total"] = self.timesheetData.totalHour;
            tmp["job_id"] = self.timesheetData.job;
            tmp["task"] = self.timesheetData.category;
            tmp["user_id"] = JSON.parse(localStorage.getItem('userData')).id;
            tmp["description"] = self.timesheetData.description;
            tmp["rework_check"] = self.timesheetData.rework =="0" || self.timesheetData.rework.length == 0 ? 0 : 1;
            request.push(tmp);
          var postData = {
            timesheet_data: request,
            removed_ids: [],
            pwa_flag : 1,
            page_name: 'Current Timesheet',
            timesheet_detail_prev : self.timesheet_detail_prev,
            user_id: JSON.parse(localStorage.getItem('userData')).id
        };
        let time_sheet_id = this.$route.params.id;
        let message = self.$route.params.detailId ?  "Timesheet Updated" :"Timesheet Created" ;
        this.isSaved = true;
        this.validateLineupAssignmentBeforeUpdate(postData, header, time_sheet_id, message)
      }
      // else {
      //   Vue.$toast.error('Unable to create Timesheet', {
      //       position: 'top'
      //       });
      // }
    },
    validateLineupAssignmentBeforeUpdate(postData, header, timeSheetId, message) {
      let self = this;
      axios.post(this.constants.api_url + 'timesheet/validate-lineup-assignment', postData, header)
        .then(function (res) {
          const hasConflicts = res && res.data && res.data.data && res.data.data.has_conflicts;
          if (hasConflicts) {
            self.pendingUpdatePostData = { postData, timeSheetId, message };
            self.showAssignmentWarningPopup = true;
            return;
          }
          self.submitUpdateTimesheet(postData, header, timeSheetId, message);
        })
        .catch(function () {
          self.submitUpdateTimesheet(postData, header, timeSheetId, message);
        });
    },
    submitUpdateTimesheet(postData, header, timeSheetId, message) {
      let self = this;
      axios.post(this.constants.api_url + 'timesheet/update/' + this.$route.params.id, postData, header)
        .then(function (res) {
          if (res.data.flag == true) {
            self.$router.push('/timesheets/currentView/' + timeSheetId)
            Vue.$toast.success(message, {
              position: 'top'
            });
          } else {
            Vue.$toast.error(res.data.message, {
              position: 'top'
            });
          }
        })
        .catch(e => {
          Vue.$toast.error((e && e.response && e.response.data && e.response.data.message) || e.message || 'Unable to save timesheet', {
            position: 'top'
          });
        })
        .finally(function () {
          self.isSaved = false;
        });
    },
    continueAfterAssignmentWarning() {
      const header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      };
      this.showAssignmentWarningPopup = false;
      if (this.pendingUpdatePostData) {
        const payload = this.pendingUpdatePostData;
        this.pendingUpdatePostData = null;
        this.submitUpdateTimesheet(payload.postData, header, payload.timeSheetId, payload.message);
      }
    },
    cancelAssignmentWarning() {
      this.showAssignmentWarningPopup = false;
      this.pendingUpdatePostData = null;
      this.isSaved = false;
    },
    calculateTotalHours (){
      let self = this;
      if(/\D/g.test(self.timesheetData.break))
        self.timesheetData.break = self.timesheetData.break.replace(/\D/g,'');
      let total = 0;
      var dur = moment.duration(moment(self.timesheetData.timeOut).diff((moment(self.timesheetData.timeIn))));
      total = dur.asHours().toFixed(2);
      var tmp = total - (self.timesheetData.break / 60)
      self.timesheetData.totalHour = tmp.toFixed(2)

    },
    selectedJob (query){
      let self = this;
      self.timesheetData.job = query.id.toString()
    },

  }
}
</script>

<style>
.assignment-warning-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.assignment-warning-modal {
  background: #fff;
  border-radius: 8px;
  width: 92%;
  max-width: 460px;
  padding: 20px;
}

.assignment-warning-modal h3 {
  margin: 0 0 10px;
}

.assignment-warning-modal p {
  margin: 0;
}

.assignment-warning-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

</style>
